// export this package's api
import QueueAnim from './QueueAnim';

export default QueueAnim;



// WEBPACK FOOTER //
// ./src/index.js